// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainView_mainContainer__QrKpQ"};